import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { VehicleParameters } from "../../components/Layouts/Insurance/VehicleParameters";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import BookingGetters from "../../store/onlineBooking/getters";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BookingDetails } from "../../@types/Booking/bookingDetails";
import { FaRegEdit } from "react-icons/fa";
import { BiSolidDownArrow, BiSolidUpArrow } from "react-icons/bi";
import { getParentOrigin, allowedOrigins } from "../../helpers/iframeSource";

function Recep({
  activeStep,
  selectedVehicle,
  updateActiveSteps = () => {},
  selectedFields,
  vehiclePrice,
  insurancePrice,
  onlyExtrasPrice,
  totalPrice,
  isPaymentPage,
  divRef,
  offsetFromTop,
  fromAnagraphDriver = false,
}) {
  const istabletScreen = window.innerWidth >= 768 && window.innerWidth <= 1220;
  const isSmallScreen = window.innerWidth <= 768;
  const isDesktopScreen = window.innerWidth >= 1310;
  const textResource = BookingGetters.getTextResource()?.data ?? [];
  const [isExpanded1, setIsExpanded1] = useState(true);
  const [isExpanded2, setIsExpanded2] = useState(false);
  const [isExpanded3, setIsExpanded3] = useState(false);
  const [isExpanded4, setIsExpanded4] = useState(false);
  const [isExpanded5, setIsExpanded5] = useState(false);
  const toggleExpand1 = () => {
    setIsExpanded2(false);
    setIsExpanded3(false);
    setIsExpanded4(false);
    setIsExpanded5(false);
    setIsExpanded1(!isExpanded1);
  };
  const toggleExpand2 = () => {
    const allowedSteps = [1, 2, 3, 6, 7, 8, 9, 11];
    if (allowedSteps.includes(activeStep)) {
      setIsExpanded1(false);
      setIsExpanded3(false);
      setIsExpanded4(false);
      setIsExpanded5(false);
      setIsExpanded2(!isExpanded2);
    }
  };
  const toggleExpand3 = () => {
    const resetExpansions = () => {
      setIsExpanded1(false);
      setIsExpanded2(false);
      setIsExpanded4(false);
      setIsExpanded5(false);
    };

    const alwaysResetSteps = [2, 6, 7, 9, 11];
    const toggleSteps = [1, ...alwaysResetSteps, 3];

    if (
      activeStep === 1 &&
      selectedFields.insurance == null &&
      Object.keys(selectedFields.options).length === 0
    ) {
      resetExpansions();
      setIsExpanded3(false);
    } else if (toggleSteps.includes(activeStep)) {
      resetExpansions();
      setIsExpanded3(!isExpanded3);
    }
  };
  const toggleExpand4 = () => {
    if (activeStep == 3 || activeStep == 6) {
      setIsExpanded1(false);
      setIsExpanded3(false);
      setIsExpanded2(false);
      setIsExpanded5(false);
      setIsExpanded4(!isExpanded4);
    }
  };
  const toggleExpand5 = () => {
    const allowedSteps = [1, 2, 3, 6, 7, 8, 9, 11];
    if (allowedSteps.includes(activeStep)) {
      setIsExpanded1(false);
      setIsExpanded3(false);
      setIsExpanded2(false);
      setIsExpanded4(false);
      setIsExpanded5(!isExpanded5);
    }
  };
  useEffect(() => {
    if (activeStep == 1 && Object.keys(selectedFields.options).length > 0) {
      setIsExpanded1(false);
      setIsExpanded2(true);
      setIsExpanded3(false);
      setIsExpanded4(false);
      setIsExpanded5(false);
    }
  }, [Object.keys(selectedFields.options).length]);
  useEffect(() => {
    if (activeStep == 1 && Object.keys(selectedFields.options).length >= 0) {
      setIsExpanded1(false);
      setIsExpanded2(true);
      setIsExpanded3(false);
      setIsExpanded4(false);
      setIsExpanded5(false);
    } else if (activeStep == 1) {
      setIsExpanded1(false);
      setIsExpanded2(false);
      setIsExpanded3(false);
      setIsExpanded4(false);
      setIsExpanded5(true);
    } else if (activeStep == 2 && selectedFields.insurance) {
      setIsExpanded2(false);
      setIsExpanded3(true);
      setIsExpanded4(false);
      setIsExpanded1(false);
      setIsExpanded5(false);
    } else if (activeStep == 3 || activeStep == 6) {
      setIsExpanded2(false);
      setIsExpanded3(false);
      setIsExpanded4(true);
      setIsExpanded1(false);
      setIsExpanded5(false);
    }
  }, [activeStep]);
  useEffect(() => {
    if (selectedFields.insurance && activeStep == 2) {
      setIsExpanded3(true);
      setIsExpanded1(false);
      setIsExpanded2(false);
      setIsExpanded4(false);
      setIsExpanded5(false);
    }
  }, [selectedFields, activeStep]);
  const { t: translate } = useTranslation();
  const navigation = useNavigate();
  const bookingInformation: BookingDetails = BookingGetters.getBookingDetails();
  const handleForwardClick = () => {
    setVisibleCards(visibleCards.map((index) => index + 1));
  };
  const handleBackwardClick = () => {
    setVisibleCards(visibleCards.map((index) => index - 1));
  };
  const [visibleCards, setVisibleCards] = useState([0, 1]);
  const appSettings = BookingGetters.getAppSettings();
  const redirectUrl = appSettings && appSettings["redirectUrl"];
  const handleEdit = () => {
    navigation("/embed");
  };
  const [userId] = useState(localStorage.getItem("userID"));
  const isLightMode =
    (activeStep === 1 && !Object.keys(selectedFields.options).length) ||
    (activeStep === 2 && !selectedFields.insurance) ||
    isPaymentPage ||
    activeStep === 3 ||
    activeStep === 6;

  const parentOrigin = getParentOrigin();
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

  const hideIframe = () => {
    window.parent.postMessage(
      {
        event_id: "hideIframe",
      },
      targetOrigin
    );
  };
  const isIphoneScreen = window.innerWidth >= 400 && window.innerWidth <= 768;
  const isAndroidScreen = window.innerWidth <= 400;
  const renderInsuranceDetails = (insurance) => {
    if (!insurance) return null;

    return (
      <div className="text-left ml-2 mr-2" style={{ paddingRight: "24px" }}>
        <div
          className="flex flex-col"
          style={{
            fontFamily: "MBCorpoSText-Regular-Web-new",
            color: "#FFFFFF",
            fontSize: "small",
          }}
        >
          <div className="flex justify-between">
            <span className="pt-1 pb-1">{insurance.details}</span>
            <span style={{ fontFamily: "MBCorpoATextCond-Regular-Web" }}>
              {insurance.name}
            </span>
            <span style={{ fontWeight: "bold" }}>
              {insurance.price} {"€"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const getOptionalDescription = (value) => {
    return value?.details?.substring(0, 15) || "";
  };

  const getBookingTextDescription = (value, textResource) => {
    const item = textResource?.find((item) => item.key === value?.name);
    return item?.body?.substring(0, 15) || value?.name;
  };

  const renderOptionTitle = (value, appSettings, textResource) => {
    if (!value || !appSettings) return "";

    const { showOptionalDescription, showDescFromBookingText } = appSettings;

    if (showOptionalDescription && value.details) {
      return getOptionalDescription(value);
    }

    if (showDescFromBookingText && Array.isArray(textResource)) {
      return getBookingTextDescription(value, textResource);
    }

    return value.name;
  };

  const renderOptionItem = (key, value, appSettings, textResource) => (
    <div key={key} className="flex justify-between ml-[9px]">
      <span
        title={
          appSettings?.showOptionalDescription
            ? value?.details
            : appSettings?.showDescFromBookingText
            ? textResource.find((item) => item.key === value?.name)?.body ||
              value?.name
            : value?.name
        }
        style={{ fontFamily: "MBCorpoSText-Regular-Web-new" }}
      >
        {renderOptionTitle(value, appSettings, textResource)}
      </span>
      <span className="mr-2" style={{ fontWeight: "bold" }}>
        <span>{value?.quantity * value?.price}</span> <span> {"€"}</span>
      </span>
    </div>
  );

  const renderExtraOptions = (options, appSettings, textResource) => {
    if (!Object.values(options).length) return <span></span>;

    return (
      <div className="text-black" style={{ overflow: "auto" }}>
        {Object.keys(options).length > 0 && (
          <div className="text-left">
            <div
              style={{
                fontFamily: "MBCorpoSText-Regular-Web-new",
                color: "#FFFFFF",
              }}
            >
              <div
                className="mr-2"
                style={{ fontSize: "small", paddingRight: "16px" }}
              >
                {Object.entries(options)
                  .filter(
                    ([, value]) =>
                      value?.price !== undefined && value?.price >= 0
                  )
                  .map(([key, value]) => {
                    return renderOptionItem(
                      key,
                      value,
                      appSettings,
                      textResource
                    );
                  })}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const cards = [
    {
      label: (
        <div
          className="flex flex-col p-2 h-[145.03px]"
          style={{
            border: `2px solid #000000`,
            background: "#000000",
          }}
        >
          <div className="mb-2">
            <div className="flex justify-between">
              <h2
                className="mx-2"
                style={{
                  color: "#FFFFFF",
                  fontFamily: "MBCorpoATextCond-Regular-Web",
                  fontSize: "16px",
                }}
              >
                {translate("Date and Time")}
              </h2>
              <button
                style={{
                  color: "#FFFFFF",
                  fontSize: "small",
                }}
                onClick={() => {
                  if (redirectUrl != null && redirectUrl != "") {
                    window.location.href = redirectUrl;
                    hideIframe();
                  } else {
                    handleEdit();
                  }
                }}
              >
                {t("Edit")}
              </button>
            </div>
            <div
              style={{
                fontFamily: "MBCorpoSText-Regular-Web-new",
                fontSize: "13px",
              }}
            >
              <div className="mx-2 my-2 text-left">
                <h6
                  style={{
                    color: "#FFFFFF",
                  }}
                >
                  {translate("Drop Off")}
                  {" : "} {bookingInformation.dropOffLocationDetails.code}
                </h6>
                <div
                  style={{
                    color: "#FFFFFF",
                  }}
                >
                  <p>
                    {t("date", {
                      date: new Date(bookingInformation.dropOffDateAndTime),
                    })}{" "}
                    {new Date(bookingInformation.dropOffDateAndTime)
                      .getHours()
                      .toString()
                      .padStart(2, "0")}
                    {":"}
                    {new Date(bookingInformation.dropOffDateAndTime)
                      .getMinutes()
                      .toString()
                      .padStart(2, "0")}
                  </p>
                </div>
              </div>
              <div className="mx-2 text-left">
                <h6 style={{ color: "#FFFFFF" }}>
                  {translate("Pick Up")}
                  {" : "} {bookingInformation.pickUpLocationDetails.code}
                </h6>
                <div
                  style={{
                    color: "#FFFFFF",
                  }}
                >
                  <p>
                    {t("date", {
                      date: new Date(bookingInformation.pickUpDateAndTime),
                    })}{" "}
                    {new Date(bookingInformation.pickUpDateAndTime)
                      .getHours()
                      .toString()
                      .padStart(2, "0")}
                    {":"}
                    {new Date(bookingInformation.pickUpDateAndTime)
                      .getMinutes()
                      .toString()
                      .padStart(2, "0")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },

    {
      label: (
        <>
          <section
            className="flex flex-col h-[145.03px] p-2"
            style={{
              border: `2px solid #000000`,
              background: "#000000",
              overflow: "auto",
            }}
          >
            <div className="flex flex-row grow">
              <p
                style={{
                  color: "#FFFFFF",
                  fontFamily: "MBCorpoATextCond-Regular-Web",
                  fontSize: "16px",
                }}
                className="grow"
              >
                {translate("Car Details")}
              </p>
              <button
                className="h-fit"
                style={{
                  color: "#FFFFFF",
                  fontSize: "small",
                }}
                onClick={() => {
                  if (activeStep > 1) updateActiveSteps(1);
                }}
              >
                {t("Edit")}
              </button>
            </div>
            <p
              style={{
                color: "#FFFFFF",
                fontFamily: "MBCorpoATextCond-Regular-Web",
                fontSize: "14px",
              }}
            >
              {selectedVehicle?.vehicleDetails?.Vehicle?.VehMakeModel?.Name}
            </p>
          </section>
        </>
      ),
    },

    {
      label: (
        <div
          className="flex flex-col p-2 h-[145.03px]"
          style={{
            border: `2px solid #000000`,
            background: "#000000",
          }}
        >
          <div className="flex justify-between">
            <div className="flex flex-row grow">
              <p
                style={{
                  color: "#FFFFFF",
                  fontFamily: "MBCorpoATextCond-Regular-Web",
                  fontSize: "16px",
                }}
                className="grow"
              >
                Extra
              </p>
              <button
                className="h-fit"
                style={{
                  color: "#FFFFFF",
                  fontSize: "small",
                }}
                onClick={() => {
                  if (activeStep > 1) updateActiveSteps(1);
                }}
              >
                {t("Edit")}
              </button>
            </div>
          </div>
          {Object.values(selectedFields.options).length ? (
            <div className="">
              {Object.keys(selectedFields.options).length > 0 && (
                <div className="pt-1 text-left">
                  <div
                    style={{
                      fontFamily: "MBCorpoATextCond-Regular-Web",
                      color: "#FFFFFF",
                      maxHeight: "39px",
                      overflowY: "auto",
                    }}
                  >
                    <div className="pt-1 pb-1" style={{ fontSize: "small" }}>
                      {Object.entries(selectedFields.options).map(
                        ([key, value]) => (
                          <div key={key} className="flex justify-between">
                            <span
                              title={
                                appSettings?.showOptionalDescription
                                  ? value?.details
                                  : appSettings?.showDescFromBookingText
                                  ? textResource.find(
                                      (item) => item.key === value?.name
                                    )?.body || value?.name
                                  : value?.name
                              }
                            >
                              {appSettings?.showOptionalDescription
                                ? value?.details?.substring(0, 15)
                                : appSettings?.showDescFromBookingText
                                ? textResource
                                    .find((item) => item.key === value?.name)
                                    ?.body?.substring(0, 15) || value?.name
                                : value?.name}{" "}
                            </span>
                            <span style={{ fontWeight: "bold" }}>
                              {"€"}
                              {value?.price}
                            </span>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <span></span>
          )}
          <div className="flex justify-between">
            <h2
              style={{
                color: "#FFFFFF",
                fontFamily: "MBCorpoATextCond-Regular-Web",
                fontSize: "16px",
              }}
            >
              {translate("Insurance")}
            </h2>
            <button
              style={{
                color: "#FFFFFF",
                fontSize: "small",
              }}
              onClick={() => {
                if (activeStep > 0) updateActiveSteps(0);
                handleBackwardClick();
              }}
            >
              {t("Edit")}
            </button>
          </div>
          {selectedFields.insurance && (
            <div className="pt-1 text-left">
              <div
                className="pt-1"
                style={{
                  fontFamily: "MBCorpoATextCond-Regular-Web",
                  color: "#FFFFFF",
                  maxHeight: "39px",
                  overflowY: "auto",
                }}
              >
                <span className="pt-1 pb-1" style={{ fontSize: "small" }}>
                  {selectedFields.insurance?.details}
                </span>
                <span style={{ fontSize: "small" }}>
                  {selectedFields.insurance?.name}
                </span>
              </div>
              <div
                style={{
                  color: "#FFFFFF",
                }}
              >
                <span
                  style={{
                    fontSize: "small",
                    fontWeight: "bold",
                  }}
                >
                  {"€"}
                  {selectedFields.insurance?.price}
                </span>
              </div>
            </div>
          )}
        </div>
      ),
    },

    {
      label: (
        <section
          className="flex flex-col h-[145.03px] p-2"
          style={{
            border: `2px solid #000000`,
            background: "#000000",
            fontFamily: "MBCorpoATextCond-Regular-Web",
          }}
        >
          <div className="text-[#FFFFFF]" style={{ fontSize: "14px" }}>
            <div className="p-1 flex flex-col space-y-2">
              <div className="flex justify-between">
                <span
                  className="font-semibold"
                  style={{
                    color: "#FFFFFF",
                    fontSize: "16px",
                  }}
                >
                  {translate("Total Amount")}
                </span>
                <span
                  style={{
                    color: "#0078D6",
                    fontSize: "21px",
                    marginTop: "-9px",
                    fontWeight: "bolder",
                  }}
                >
                  {totalPrice?.toFixed(2) || 0}
                  {"€"}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">
                  {translate("Total Rental")}
                </span>
                <span>
                  {vehiclePrice?.toFixed(2) || 0}
                  {"€"}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">{translate("Extras")}</span>
                <span>
                  {onlyExtrasPrice?.toFixed(2) || 0}
                  {"€"}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">{translate("Insurance")}</span>
                <span>
                  {insurancePrice?.toFixed(2) || 0}
                  {"€"}
                </span>
              </div>
            </div>
          </div>
        </section>
      ),
    },
  ];
  return (
    <>
      {activeStep !== 4 && activeStep !== 5 && activeStep !== 0 && (
        <div
          style={{
            display: isSmallScreen ? "" : "flex",
            justifyContent: "center",
            alignItems: "center",
            ...(activeStep !== 0 && !istabletScreen && !isSmallScreen
              ? {
                  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${selectedVehicle?.Vehicle?.vehicleGroupPic})`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  height: "513px",
                }
              : {}),
          }}
        >
          {istabletScreen == true && activeStep != 0 && activeStep != 4 && (
            <>
              <div className="box-border box-border py-4 flex flex-row hidden md:flex gap-1 sticky top-0 z-[10] bg-[#FFFFFF] w-full">
                <div className="box-border py-4 flex flex-row hidden md:flex gap-1 sticky top-0 z-[10] bg-[#FFFFFF] w-full">
                  <button
                    style={{
                      color: visibleCards[0] === 0 ? "grey" : "black",
                    }}
                    onClick={handleBackwardClick}
                    disabled={visibleCards[0] === 0}
                  >
                    <ArrowBackIosNewIcon />
                  </button>
                  {cards.map((e, index) => {
                    if (visibleCards.includes(index)) {
                      return (
                        <div key={index} className="w-1/2">
                          {e.label}
                        </div>
                      );
                    }
                    return null;
                  })}
                  <button
                    style={{
                      color:
                        visibleCards[1] === cards.length - 1 ||
                        selectedVehicle == undefined ||
                        activeStep != 2
                          ? "grey"
                          : "black",
                    }}
                    onClick={handleForwardClick}
                    disabled={
                      visibleCards[1] === cards.length - 1 ||
                      selectedVehicle == undefined
                    }
                  >
                    <ArrowForwardIosIcon />
                  </button>
                </div>
              </div>
            </>
          )}{" "}
          {isSmallScreen == true && activeStep != 4 && (
            <>
              <div>
                {userId != null &&
                  userId !== "null" &&
                  userId !== "" &&
                  isSmallScreen}
              </div>
              <div
                className={`bg-white shadow-lg scrollable${
                  userId != null &&
                  userId !== "null" &&
                  userId !== "" &&
                  isSmallScreen
                    ? ""
                    : ""
                }`}
                ref={divRef}
                id="my-element"
              >
                <div
                  className="pt-0"
                  style={{
                    ...(activeStep !== 4 &&
                      activeStep !== 0 &&
                      isSmallScreen && {
                        /*position: "relative",*/
                        color: "white",
                        fontFamily: "MBCorpoATextCond-Regular-Web",
                        padding: "50px",
                        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${selectedVehicle?.Vehicle?.vehicleGroupPic})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundColor: "rgba(0, 0, 0, 0.9)",
                        marginTop: "-9px",
                      }),
                  }}
                >
                  <div
                    style={{
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      zIndex: 1,
                    }}
                  />
                  <div
                    style={{
                      zIndex: 2,
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      top: "20px",
                      left: "-20px",
                      color: "white",
                      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "20px",
                        paddingBottom: "2px",
                      }}
                    >
                      {selectedVehicle?.Vehicle?.VehMakeModel?.Name}
                    </span>
                    <br />
                  </div>
                </div>
                <div
                  className="flex flex-col grow"
                  style={{
                    marginTop: "8px",
                    marginLeft: isSmallScreen ? "" : "-14px",
                    marginBottom: "8px",
                  }}
                >
                  {activeStep !== 0 && activeStep !== 4 && (
                    <VehicleParameters
                      specifications={
                        selectedVehicle?.Vehicle?.vehicleParameter
                      }
                    />
                  )}
                </div>
                <div
                  className={`bg-white shadow-lg ${
                    (isAndroidScreen && offsetFromTop <= -40.96) ||
                    (isIphoneScreen && offsetFromTop <= -41.96)
                      ? " top-10 left-0 right-0"
                      : ""
                  }`}
                  style={{ zIndex: "800" }}
                >
                  <div
                    className="flex flex-col grow"
                    style={{ marginBottom: "1px" }}
                  >
                    <div className="">
                      <div
                        className="flex justify-between px-4"
                        style={!isExpanded1 ? { background: "black" } : {}}
                      >
                        <h2
                          className={`text-lg text-black`}
                          style={
                            !isExpanded1
                              ? {
                                  color: "white",
                                  fontFamily: "MBCorpoATextCond-Regular-Web",
                                }
                              : {
                                  color: "black",
                                  fontFamily: "MBCorpoATextCond-Regular-Web",
                                }
                          }
                        >
                          {translate("Date and Time")}
                        </h2>

                        <button
                          style={
                            !isExpanded1
                              ? { color: "white" }
                              : { color: "black" }
                          }
                          onClick={toggleExpand1}
                        >
                          {isExpanded1 ? (
                            <BiSolidUpArrow />
                          ) : (
                            <BiSolidDownArrow />
                          )}
                        </button>
                      </div>

                      {isExpanded1 && (
                        <div>
                          {activeStep !== 4 && activeStep !== 6 && (
                            <button
                              className={"float-right"}
                              style={{
                                fontFamily: "MBCorpoATextCond-Regular-Web",
                                color: "black",
                                marginRight: "3.5%",
                              }}
                              onClick={() => {
                                if (redirectUrl != null && redirectUrl !== "") {
                                  window.location.href = redirectUrl;
                                  hideIframe();
                                } else {
                                  handleEdit();
                                }
                              }}
                            >
                              <FaRegEdit />
                            </button>
                          )}

                          <div
                            className="flex flex-row text-black"
                            style={{
                              marginLeft: "17px",
                              fontFamily: "MBCorpoSText-Regular-Web-new",
                            }}
                          >
                            <div className="pt-1 text-left">
                              <h6
                                className="text-sm"
                                style={{
                                  fontFamily: "MBCorpoSText-CondLight-Web",
                                }}
                              >
                                {translate("Pick Up")}
                              </h6>
                              <div>
                                <p
                                  style={{
                                    fontFamily: "MBCorpoSText-CondLight-Web",
                                  }}
                                >
                                  {t("date", {
                                    date: new Date(
                                      bookingInformation.pickUpDateAndTime
                                    ),
                                  })}{" "}
                                  {new Date(
                                    bookingInformation.pickUpDateAndTime
                                  )
                                    .getHours()
                                    .toString()
                                    .padStart(2, "0")}
                                  :
                                  {new Date(
                                    bookingInformation.pickUpDateAndTime
                                  )
                                    .getMinutes()
                                    .toString()
                                    .padStart(2, "0")}
                                </p>
                              </div>
                            </div>
                            <div
                              className="pt-1 text-left"
                              style={{
                                marginLeft: "20px",
                              }}
                            >
                              <h6
                                className="text-sm"
                                style={{
                                  fontFamily: "MBCorpoSText-CondLight-Web",
                                }}
                              >
                                {translate("Drop Off")}
                              </h6>
                              <div>
                                <p
                                  style={{
                                    fontFamily: "MBCorpoSText-CondLight-Web",
                                  }}
                                >
                                  {t("date", {
                                    date: new Date(
                                      bookingInformation.dropOffDateAndTime
                                    ),
                                  })}{" "}
                                  {new Date(
                                    bookingInformation.dropOffDateAndTime
                                  )
                                    .getHours()
                                    .toString()
                                    .padStart(2, "0")}
                                  :
                                  {new Date(
                                    bookingInformation.dropOffDateAndTime
                                  )
                                    .getMinutes()
                                    .toString()
                                    .padStart(2, "0")}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className="flex flex-col grow"
                    style={{ marginBottom: "0.6px" }}
                  >
                    <div className="">
                      <div
                        className="flex justify-between px-4"
                        style={!isExpanded5 ? { background: "black" } : {}}
                      >
                        <h2
                          className={`text-lg text-black`}
                          style={
                            !isExpanded5
                              ? {
                                  color: "white",
                                  fontFamily: "MBCorpoATextCond-Regular-Web",
                                }
                              : {
                                  color: "black",
                                  fontFamily: "MBCorpoATextCond-Regular-Web",
                                }
                          }
                        >
                          {translate("Vehicle Details")}
                        </h2>

                        <button
                          style={
                            !isExpanded5
                              ? { color: "white" }
                              : { color: "black" }
                          }
                          onClick={toggleExpand5}
                        >
                          {isExpanded5 ? (
                            <BiSolidUpArrow />
                          ) : (
                            <BiSolidDownArrow />
                          )}
                        </button>
                      </div>

                      {selectedVehicle && isExpanded5 && (
                        <div>
                          {activeStep !== 4 && activeStep !== 6 && (
                            <button
                              className={"float-right"}
                              style={{
                                fontFamily: "MBCorpoATextCond-Regular-Web",
                                color: "black",
                                marginRight: "3.5%",
                              }}
                              onClick={() => {
                                if (activeStep > 0) updateActiveSteps(0);
                              }}
                            >
                              <FaRegEdit />
                            </button>
                          )}
                          <div className="flex flex-row text-black">
                            <div className=" text-left">
                              <div
                                className=""
                                style={{
                                  fontFamily: "MBCorpoSText-CondLight-Web",
                                  marginLeft: "17px",
                                }}
                              >
                                {selectedVehicle.Vehicle?.VehMakeModel?.Name}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <section
                    className={`flex flex-col w-full grow p-0 bg-[#FFFFFF] mt-[1px] `}
                    style={
                      !isExpanded2
                        ? {
                            background: "black",
                            color: "white",
                            fontFamily: "MBCorpoATextCond-Regular-Web",
                            marginBottom: "1px",
                          }
                        : {}
                    }
                  >
                    {/* Extras Section */}
                    <div className="flex flex-row items-center justify-between grow">
                      <div className="flex flex-col w-full pr-2">
                        <p
                          className="text-lg text-black px-4"
                          style={{
                            fontFamily: "MBCorpoATextCond-Regular-Web",
                            color: !isExpanded2 ? "white" : "",
                          }}
                        >
                          Extras
                        </p>
                        {Object.values(selectedFields.options).length > 0 &&
                        isExpanded2 ? (
                          <div
                            className="scrollable"
                            style={{
                              maxHeight: "80px",
                              overflowY: "auto",
                            }}
                          >
                            <span
                              className="flex flex-col text-black"
                              style={{
                                marginLeft: "17px",
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                              }}
                            >
                              {Object.keys(selectedFields.options).length >
                                0 && (
                                <div className="pt-1 text-left">
                                  <div className="pt-1">
                                    {Object.entries(selectedFields.options).map(
                                      ([key, value]) => (
                                        <div
                                          key={key}
                                          className="flex justify-between"
                                          style={{
                                            alignItems: "center",
                                          }}
                                        >
                                          <span
                                            title={value?.details}
                                            style={{
                                              fontFamily:
                                                "MBCorpoSText-CondLight-Web",
                                            }}
                                          >
                                            {value?.details} {"   "}
                                          </span>
                                          <span
                                            style={{
                                              fontWeight: "bold",
                                              marginLeft: "17%",
                                            }}
                                          >
                                            {value?.price}
                                            {"€"}
                                          </span>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              )}
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <span className="flex flex-col">
                        <span>
                          <button
                            onClick={toggleExpand2}
                            className="px-4 float-right"
                            style={
                              !isExpanded2
                                ? { color: "white" }
                                : { color: "black" }
                            }
                          >
                            {isExpanded2 ? (
                              <BiSolidUpArrow />
                            ) : (
                              <BiSolidDownArrow />
                            )}
                          </button>
                        </span>

                        {isExpanded2 && activeStep !== 6 && (
                          <span className="ml-[35%]">
                            <button
                              onClick={() => {
                                if (activeStep > 0) updateActiveSteps(1);
                              }}
                              style={{ color: "black" }}
                            >
                              <FaRegEdit />
                            </button>
                          </span>
                        )}
                      </span>
                    </div>
                  </section>

                  <section
                    className="flex flex-col w-full grow p-0 bg-[#FFFFFF]"
                    style={
                      !isExpanded3
                        ? {
                            background: "black",
                            color: "white",
                            marginBottom: "1px",
                          }
                        : {}
                    }
                  >
                    {/* Insurance Section */}
                    <div className="flex flex-row items-center justify-between grow">
                      <div className="flex flex-col w-full pr-2">
                        <p
                          className="text-lg text-black px-4"
                          style={{
                            fontFamily: "MBCorpoATextCond-Regular-Web", // Always applied
                            ...(!isExpanded3
                              ? {
                                  color: "white",
                                }
                              : {}),
                          }}
                        >
                          {translate("Insurance")}
                        </p>
                        {selectedFields.insurance && isExpanded3 && (
                          <div
                            style={{
                              overflowY: "auto",
                            }}
                          >
                            <div
                              className="flex flex-col text-black"
                              style={{
                                marginLeft: "17px",
                              }}
                            >
                              <div className="pt-1 text-left">
                                <div className="pt-1 flex justify-between">
                                  <span
                                    className="pt-1 pb-1"
                                    style={{
                                      fontFamily: "MBCorpoSText-CondLight-Web",
                                    }}
                                  >
                                    {selectedFields.insurance?.details}
                                  </span>
                                  <span
                                    style={{
                                      fontFamily: "MBCorpoSText-CondLight-Web",
                                    }}
                                  >
                                    {selectedFields.insurance?.name}
                                  </span>
                                  <span
                                    style={{
                                      fontFamily: "MBCorpoSText-CondLight-Web",
                                      marginLeft: "17%",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {selectedFields.insurance?.price}
                                    {"€"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <span>
                        <span className="flex flex-col">
                          <button
                            onClick={toggleExpand3}
                            className="px-4"
                            style={
                              !isExpanded3
                                ? { color: "white" }
                                : { color: "black" }
                            }
                          >
                            {isExpanded3 ? (
                              <BiSolidUpArrow />
                            ) : (
                              <BiSolidDownArrow />
                            )}
                          </button>
                        </span>
                        {isExpanded3 && activeStep !== 6 && (
                          <span className="ml-[35%]">
                            <button
                              onClick={() => {
                                if (activeStep > 0) updateActiveSteps(2);
                              }}
                              style={{ color: "black" }}
                            >
                              <FaRegEdit />
                            </button>
                          </span>
                        )}
                      </span>
                    </div>
                  </section>

                  <section
                    className="flex flex-col w-full grow p-0"
                    style={{
                      ...(!isExpanded4
                        ? {
                            background: "black",
                            fontFamily: "MBCorpoATextCond-Regular-Web",
                            marginBottom: "1px",
                          }
                        : {}),
                    }}
                  >
                    <div className="flex flex-row justify-between items-center w-full">
                      <p
                        className="text-lg text-black grow px-4"
                        style={
                          !isExpanded4
                            ? {
                                color: "white",
                                fontFamily: "MBCorpoATextCond-Regular-Web",
                                fontSize: "20px",
                              }
                            : {
                                color: "black",
                                fontFamily: "MBCorpoATextCond-Regular-Web",
                                fontSize: "20px",
                              }
                        }
                      >
                        {translate("Total Amount")}
                      </p>
                      <span
                        style={{
                          color: "#0078D6",
                          fontSize: "20px",
                          fontWeight: "bolder",
                          fontFamily: "MBCorpoSText-CondLight-Web",
                        }}
                      >
                        {parseFloat(totalPrice)?.toFixed(2) || 0}
                        {"€"}
                      </span>
                      <button
                        style={
                          !isExpanded4
                            ? {
                                color: "white",
                                fontFamily: "MBCorpoATextCond-Regular-Web",
                              }
                            : {
                                color: "black",
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                              }
                        }
                        onClick={toggleExpand4}
                        className={"px-4"}
                      >
                        {isExpanded4 ? (
                          <BiSolidUpArrow />
                        ) : (
                          <BiSolidDownArrow />
                        )}
                      </button>
                    </div>
                    {(activeStep == 3 && isExpanded4) ||
                    (activeStep == 6 && isExpanded4) ? (
                      <div
                        className="text-black"
                        style={{
                          fontFamily: "MBCorpoSText-CondLight-Web",
                        }}
                      >
                        <div className="p-1 flex flex-col space-y-2 px-4 bg-[#FFFFFF]">
                          <div className="flex justify-between bg-[#FFFFFF]">
                            <span className="font-normal">
                              {" "}
                              {translate("Total Rental")}
                            </span>
                            <span className="mr-[8%]">
                              {vehiclePrice?.toFixed(2) || 0}
                              {"€"}
                            </span>
                          </div>
                          <div className="flex justify-between bg-[#FFFFFF]">
                            <span className="font-normal"> {"Extras"}</span>
                            <span className="mr-[8%]">
                              {onlyExtrasPrice?.toFixed(2) || 0}
                              {"€"}
                            </span>
                          </div>
                          <div className="flex justify-between bg-[#FFFFFF]">
                            <span className="font-normal">
                              {translate("Insurance")}
                            </span>
                            <span className="mr-[8%]">
                              {insurancePrice?.toFixed(2) || 0}
                              {"€"}
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <span></span>
                    )}
                  </section>
                </div>
              </div>
            </>
          )}
          {isDesktopScreen == true &&
            activeStep != 4 &&
            activeStep != 5 &&
            activeStep != 0 && (
              <div>
                <div
                  className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
                  style={{
                    paddingTop: "8rem",
                    marginLeft: "auto",
                    marginRight: "auto",
                    justifyContent: "center", // Center the cards
                  }}
                >
                  <span
                    style={{
                      fontSize: "38px",
                      fontWeight: "600px",
                      fontFamily: "MBCorpoATitle-Regular-Web",
                    }}
                  >
                    {" "}
                    {selectedVehicle?.Vehicle?.VehMakeModel?.Name}
                  </span>
                  <br />
                  <br />
                  <span
                    style={{
                      fontSize: "24px",
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    }}
                  >
                    {bookingInformation?.pickUpLocationDetails?.dealerName}
                  </span>
                  <br />
                  <span
                    style={{
                      fontSize: "24px",
                      fontFamily: "MBCorpoSText-CondLight-Web",
                      paddingTop: "7px",
                      display: "block",
                    }}
                  >
                    {
                      bookingInformation?.pickUpLocationDetails
                        ?.locationDescription
                    }
                  </span>
                </div>

                <div
                  className="box-border box-border flex flex-row hidden md:flex gap-1 sticky z-[10]  w-full"
                  style={{
                    marginTop: "5%",
                    marginLeft: "auto",
                    marginRight: "auto",
                    justifyContent: "center",
                  }}
                >
                  {[
                    {
                      label: (
                        <div
                          className="flex flex-col p-2 h-[145.03px] w-[268.16px]"
                          style={{
                            overflowY: "auto",
                            border:
                              activeStep != 5 ||
                              activeStep != 6 ||
                              activeStep == 7
                                ? "rgba(0, 0, 0, 0.7)"
                                : "2px solid #000000",
                            background:
                              activeStep != 5 ||
                              activeStep != 6 ||
                              activeStep == 7
                                ? "rgba(0, 0, 0, 0.7)"
                                : "#000000",
                          }}
                        >
                          <div className="mb-2 ml-2 mr-2">
                            <div className="flex justify-between">
                              <h2
                                className="mx-2"
                                style={{
                                  color: "#FFFFFF",
                                  fontFamily: "MBCorpoATextCond-Regular-Web",
                                  fontSize: "16px",
                                }}
                              >
                                {translate("Date and Time")}
                              </h2>
                              {activeStep != 4 &&
                                activeStep != 6 &&
                                !fromAnagraphDriver && (
                                  <button
                                    onClick={() => {
                                      if (
                                        redirectUrl != null &&
                                        redirectUrl != ""
                                      ) {
                                        window.location.href = redirectUrl;
                                        hideIframe();
                                      } else {
                                        handleEdit();
                                      }
                                    }}
                                  >
                                    <img
                                      className="h-6 cursor-pointer h-[22px]"
                                      src="/assets/images/editImage.png"
                                      alt="Edit"
                                    />
                                  </button>
                                )}
                            </div>
                            <div
                              style={{
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                                fontSize: "13px",
                              }}
                            >
                              <div className="mx-2 my-2 text-left">
                                <h6 style={{ color: "#FFFFFF" }}>
                                  {translate("Pick Up")}
                                  {" : "}{" "}
                                  {
                                    bookingInformation.pickUpLocationDetails
                                      .locationDescription
                                  }
                                </h6>
                                <div
                                  style={{
                                    color: "#FFFFFF",
                                  }}
                                >
                                  <p>
                                    {new Date(
                                      bookingInformation.pickUpDateAndTime
                                    ).toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    })}{" "}
                                    {"- h. "}
                                    {new Date(
                                      bookingInformation.pickUpDateAndTime
                                    )
                                      .getHours()
                                      .toString()
                                      .padStart(2, "0")}
                                    {":"}
                                    {new Date(
                                      bookingInformation.pickUpDateAndTime
                                    )
                                      .getMinutes()
                                      .toString()
                                      .padStart(2, "0")}
                                  </p>
                                </div>
                              </div>
                              <div className="mx-2 my-2 text-left">
                                <h6
                                  style={{
                                    color: "#FFFFFF",
                                  }}
                                >
                                  {translate("Drop Off")}
                                  {" : "}{" "}
                                  {
                                    bookingInformation.dropOffLocationDetails
                                      .locationDescription
                                  }
                                </h6>
                                <div
                                  style={{
                                    color: "#FFFFFF",
                                  }}
                                >
                                  <p>
                                    {new Date(
                                      bookingInformation.dropOffDateAndTime
                                    ).toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    })}{" "}
                                    {"- h. "}
                                    {new Date(
                                      bookingInformation.dropOffDateAndTime
                                    )
                                      .getHours()
                                      .toString()
                                      .padStart(2, "0")}
                                    {":"}
                                    {new Date(
                                      bookingInformation.dropOffDateAndTime
                                    )
                                      .getMinutes()
                                      .toString()
                                      .padStart(2, "0")}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ),
                    },

                    {
                      label: (
                        <>
                          <section
                            className="flex flex-col h-[145.03px] w-[268.16px] p-2"
                            style={{
                              border:
                                (activeStep != 5 || activeStep != 6) &&
                                (Object.keys(selectedFields.options).length >
                                  0 ||
                                  selectedFields.insurance?.details)
                                  ? "rgba(0, 0, 0, 0.7)"
                                  : `2px solid #000000`,
                              background:
                                (activeStep != 5 || activeStep != 6) &&
                                (Object.keys(selectedFields.options).length >
                                  0 ||
                                  selectedFields.insurance?.details)
                                  ? "rgba(0, 0, 0, 0.7)"
                                  : "#000000",
                              marginLeft: "27.84px",
                            }}
                          >
                            <div className="flex justify-between ml-2 mr-2">
                              <p
                                style={{
                                  color: "#FFFFFF",
                                  fontFamily: "MBCorpoATextCond-Regular-Web",
                                  fontSize: "16px",
                                }}
                                className="grow"
                              >
                                {translate("Car Details")}
                              </p>
                              {activeStep != 4 &&
                                activeStep != 6 &&
                                !fromAnagraphDriver && (
                                  <button
                                    onClick={() => {
                                      if (activeStep > 0) updateActiveSteps(0);
                                    }}
                                  >
                                    <img
                                      className="h-6 cursor-pointer h-[22px]"
                                      src="/assets/images/editImage.png"
                                      alt="Edit"
                                    />
                                  </button>
                                )}
                            </div>
                            <p
                              className="my-2 text-left"
                              style={{
                                color: "#FFFFFF",
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                                fontSize: "14px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                marginLeft: "9px",
                              }}
                            >
                              {selectedVehicle?.Vehicle?.VehMakeModel?.Name}
                            </p>
                          </section>
                        </>
                      ),
                    },
                    {
                      label: (
                        <div
                          className="flex flex-col h-[145.03px] w-[268.16px] p-2"
                          style={{
                            border: isLightMode
                              ? "rgba(0, 0, 0, 0.7)"
                              : `2px solid #000000`,
                            background: isLightMode
                              ? "rgba(0, 0, 0, 0.7)"
                              : "#000000",
                            marginLeft: "27.84px",
                          }}
                        >
                          {/* Extras Section */}
                          <div
                            className="flex flex-col mb-1"
                            style={{ height: "63px" }}
                          >
                            <div className="flex justify-between ml-2 mr-2">
                              <p
                                style={{
                                  color: "#FFFFFF",
                                  fontFamily: "MBCorpoATextCond-Regular-Web",
                                  fontSize: "16px",
                                }}
                                className="grow"
                              >
                                Extra
                              </p>
                              {activeStep !== 4 &&
                                activeStep !== 6 &&
                                !fromAnagraphDriver && (
                                  <button
                                    onClick={() => {
                                      if (activeStep > 0) updateActiveSteps(1);
                                    }}
                                  >
                                    <img
                                      className="h-6 cursor-pointer h-[22px]"
                                      src="/assets/images/editImage.png"
                                      alt="Edit"
                                    />
                                  </button>
                                )}
                            </div>
                            {renderExtraOptions(
                              selectedFields.options,
                              appSettings,
                              textResource
                            )}
                          </div>

                          {/* Insurance Section */}
                          <div className="flex flex-col">
                            <div className="flex justify-between ml-2 mr-2">
                              <h2
                                style={{
                                  color: "#FFFFFF",
                                  fontFamily: "MBCorpoATextCond-Regular-Web",
                                  fontSize: "16px",
                                }}
                              >
                                {translate("Insurance")}
                              </h2>
                              {activeStep !== 4 &&
                                activeStep !== 6 &&
                                !fromAnagraphDriver && (
                                  <button
                                    onClick={() => {
                                      if (activeStep > 0) updateActiveSteps(2);
                                    }}
                                  >
                                    <img
                                      className="h-6 cursor-pointer h-[22px]"
                                      src="/assets/images/editImage.png"
                                      alt="Edit"
                                    />
                                  </button>
                                )}
                            </div>
                            {selectedFields.insurance &&
                              renderInsuranceDetails(selectedFields.insurance)}
                          </div>
                        </div>
                      ),
                    },

                    {
                      label: (
                        <section
                          className="flex flex-col h-[145.03px] w-[268.16px] p-2"
                          style={{
                            border:
                              activeStep == 1 ||
                              activeStep == 2 ||
                              activeStep == 7 ||
                              activeStep == 8 ||
                              activeStep == 9 ||
                              activeStep == 11 ||
                              fromAnagraphDriver
                                ? "rgba(0, 0, 0, 0.7)"
                                : `2px solid #000000`,
                            background:
                              activeStep == 1 ||
                              activeStep == 2 ||
                              activeStep == 7 ||
                              activeStep == 8 ||
                              activeStep == 9 ||
                              activeStep == 11 ||
                              fromAnagraphDriver
                                ? "rgba(0, 0, 0, 0.7)"
                                : "#000000",
                            marginLeft: "27.84px",
                            fontFamily: "MBCorpoATextCond-Regular-Web",
                          }}
                        >
                          <div className="flex flex-row grow">
                            <p
                              style={{
                                color: "#FFFFFF",
                                fontSize: "16px",
                              }}
                            ></p>
                          </div>
                          <div
                            className="text-[#FFFFFF]"
                            style={{ fontSize: "14px" }}
                          >
                            <div className="p-1 flex flex-col space-y-2 mt-[-52%] ml-2 mr-2">
                              <div className="flex justify-between">
                                <span
                                  style={{
                                    color: "#FFFFFF",
                                    fontSize: "16px",
                                  }}
                                >
                                  {translate("Total Amount")}
                                </span>
                                <span
                                  style={{
                                    color: "#0078D6",
                                    fontSize: "21px",
                                    marginTop: "-7px",
                                    fontWeight: "bolder",
                                    fontFamily: "MBCorpoATextCond-Regular-Web",
                                  }}
                                >
                                  {totalPrice?.toFixed(2) || 0}
                                  {"€"}
                                </span>
                              </div>
                              <div className="flex justify-between mt-[2%]">
                                <span
                                  style={{
                                    fontFamily: "MBCorpoSText-Regular-Web-new",
                                  }}
                                >
                                  {translate("Total Rental")}
                                </span>
                                <span>
                                  {vehiclePrice?.toFixed(2) || 0}
                                  {"€"}
                                </span>
                              </div>
                              <div className="flex justify-between">
                                <span
                                  style={{
                                    fontFamily: "MBCorpoSText-Regular-Web-new",
                                  }}
                                >
                                  {"Extras"}
                                </span>
                                <span>
                                  {onlyExtrasPrice?.toFixed(2) || 0}
                                  {"€"}
                                </span>
                              </div>
                              <div className="flex justify-between">
                                <span
                                  style={{
                                    fontFamily: "MBCorpoSText-Regular-Web-new",
                                  }}
                                >
                                  {translate("Insurance")}
                                </span>
                                <span>
                                  {insurancePrice?.toFixed(2) || 0}
                                  {"€"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </section>
                      ),
                    },
                  ].map((e, index) => {
                    return <div key={index}>{e.label}</div>;
                  })}
                </div>
              </div>
            )}
        </div>
      )}
    </>
  );
}
export default Recep;
